import React from "react";

import { useWizard } from "@/app/shared-providers/wizard-context-provider";

import { useCoverTypeContext } from "../../../provider/cover-type.provider";

export default function Title() {
  const { selectedAnswer, groupedMagnoliaData } = useCoverTypeContext();
  const { title } = groupedMagnoliaData[selectedAnswer].descriptionSection;

  const { current } = useWizard();
  const showNewButtonsLayout = current.uiElementControls?.showNewButtonsLayout;

  return (
    <h2
      data-testid="header-test-id"
      className={`
        md:!text-3xl font-header-font  text-center ${
          !showNewButtonsLayout ? "md:text-left" : ""
        } md:mb-spacing-xs mb-spacing-m leading-[21px]
        md:leading-[34.1px] text-[20px] text-surface-neutral-option-1 ${
          selectedAnswer === 0 &&
          current.uiElementControls?.showdefaultDescriptionSection
            ? "md:text-center"
            : ""
        }
      `}
    >
      {title}
    </h2>
  );
}
